<style lang="scss" scoped>
.handle {
  padding: 25px;
  .handle-row {
    width: 100%;
  }
  .empty {
    padding: 20px;
  }
}
/deep/ .input-with-select .el-input-group__prepend {
  width: 110px;
}
.filter {
  padding: 0 25px 25px 25px;
}
/deep/ .el-table__expanded-cell {
    padding: 20px 50px!important;
}
/deep/ .el-table__header-wrapper .el-table__header {
    width: auto!important;
}
</style>

<template>
  <div class="maintenance-box">
    <div class="panel">
      <el-row class="handle" :gutter="20">
        <el-col :lg="18" :md="18" :sm="18" :xl="18" :xs="18">
          <el-select v-model="symbols" filterable multiple :placeholder="language.symbolText" class="handle-row">
            <el-option v-for="(v, i) in symbolList" :key="i" :label="v.SYMBOL" :value="v.SYMBOL"> </el-option>
          </el-select>
        </el-col>
        <el-col :lg="3" :md="3" :sm="3" :xl="3" :xs="3">
          <el-button type="primary" class="handle-row" @click="getOpenTradesBySymbols">{{ reuse.refresh }}</el-button>
        </el-col>
        <el-col :lg="3" :md="3" :sm="3" :xl="3" :xs="3">
          <el-button class="handle-row" @click="export2Excel">{{ reuse.downloadExcelForms }}</el-button>
        </el-col>
      </el-row>
      <el-row class="filter">
        <el-col>
          <el-input :placeholder="language.filterText" v-model="filterVal" class="input-with-select" @change="findByKeyword">
            <el-select v-model="filterKey" slot="prepend">
              <template v-for="(v, k) in language.filterOptions">
                <el-option :label="v" :value="k" :key="k"></el-option>
              </template>
            </el-select>
          </el-input>
        </el-col>
      </el-row>
      <el-row v-loading="loading">
        <el-table :data="openTrades" border>
          <el-table-column type="expand" key="expand">
            <template slot-scope="props">
              <el-table
                :data="
                  copySymbols.map((s) => {
                    return {
                      SYMBOL: s,
                      SELL_VOLUME: props.row[`${s}_SELL_VOLUME`] || 0,
                      BUY_VOLUME: props.row[`${s}_BUY_VOLUME`] || 0,
                      VOLUME: props.row[`${s}_VOLUME`] || 0,
                      PL: props.row[`${s}_PL`] || 0,
                    }
                  })
                "
                border
                max-height="200"
                size="mini"
              >
                <template v-for="(v, k) in language.expandHead">
                  <el-table-column :prop="k" :label="v" :key="k"> 
                    <template slot-scope="scope">
                        <span :style="['PL'].includes(k) && scope.row[k] < 0 ? 'color:red;' : ''">{{ scope.row[k] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </template>
          </el-table-column>
          <template v-for="(v, i) in tableHead">
            <el-table-column :prop="v.key" fixed :label="v.value" :key="i"> 
                <template slot-scope="scope">
                    <span v-if="v.redColor" :style="+scope.row[v.key] < 0 ? 'color:red;' : ''">{{ scope.row[v.key] }}</span>
                    <span v-else>{{ scope.row[v.key] }}</span>
                </template>
            </el-table-column>
          </template>
        </el-table>
      </el-row>
      <el-row class="handle">
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
          <div class="empty"></div>
        </el-col>
        <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="9">
          <el-pagination
            :current-page="pageNum"
            :page-size="pageSize"
            :page-sizes="[5, 10, 25, 50]"
            :pager-count="5"
            :total="total"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { URL_SECURITY, URL_OPEN_TRADES, URL_SYMBOL_LIST } from 'api/api'

const data = () => {
  return {
    symbolList: [],
    symbols: [],
    copySymbols:[],
    all: [],
    allAfterFilter: [],
    openTrades: [],
    pageNum: 1,
    pageSize: 10,
    total: 0,
    loading: false,
    filterKey: 'LOGIN',
    filterVal: null,
  }
}

const mixins = [require('common/mixin/base').base({ language: 'openTrades' }), require('common/mixin/base').base({ reuse: 'reuse' })]

const computed = {
    tableHead() {
        const redColorColumns = ['EQUITY','CLOSED_PL','FLOATING_PL','PL']
        this.language.tableHead.forEach(head => {
            if(redColorColumns.includes(head.key)) head.redColor = true;
        })
        return this.language.tableHead
    }
}

const created = function () {
    Promise.all([this.$http.get(URL_SYMBOL_LIST), this.$http.get(URL_SECURITY)]).then(res=>{
        const [symbolRes, securityRes] = res
        this.symbolList = symbolRes.data.data
        securityRes.data.data.forEach(type => this.symbolList.push({SYMBOL: `*${type.TYPE}`}))
    })
}

const methods = {
  getOpenTradesBySymbols() {
    if (this.symbols.length == 0) {
      this.$message({ message: this.language.symbolText, type: 'warning' })
      return
    }
    this.copySymbols = [...this.symbols]
    this.loading = true
    this.$http.post(URL_OPEN_TRADES, { symbols: this.symbols.join(',') }).then((res) => {
      this.all = res.data.data
      this.all.forEach(row => row.MARGIN_LEVEL = `${row.MARGIN_LEVEL}%`)
      this.findByKeyword()
      this.loading = false
    })
  },
  handlePageChange(val) {
    this.pageNum = val
    this.openTrades = this.allAfterFilter.slice((val - 1) * this.pageSize, val * this.pageSize)
  },
  handleSizeChange(val) {
    this.pageNum = 1
    this.pageSize = val
    this.openTrades = this.allAfterFilter.slice(0, this.pageSize)
  },
  export2Excel() {
    const header = this.language.tableHead
    const newHead = header.slice(0, header.length)
    const expand = this.language.expandHead
    // 创建加总对象
    const totalObj = { EQUITY: 0, PL: 0, CLOSED_PL: 0, FLOATING_PL: 0 }
    // 动态添加EXCEL表头
    this.symbols.forEach((e) => {
      ;['BUY_VOLUME', 'SELL_VOLUME', 'VOLUME', 'PL'].forEach((k) => {
        const key = `${e}_${k}`
        newHead.push({ key, value: `${e} ${expand[k]}` })
        totalObj[key] = 0
      })
    })
    this.allAfterFilter.forEach((data) => Object.keys(totalObj).forEach((key) => (totalObj[key] += data[key])))
    const downloadArray = this.allAfterFilter.slice(0, this.total)
    if (downloadArray.length !== 0) {
      downloadArray.push({})
      downloadArray.push(totalObj)
    }
    require.ensure([], () => {
      const { export_json_to_excel } = require('@/vendor/Export2Excel')
      const tHeader = newHead.map((v) => v.value)
      const filterVal = newHead.map((v) => v.key)
      const data = downloadArray.map((v) => filterVal.map((j) => v[j]))
      export_json_to_excel(tHeader, data, this.language.excelName, { moneyStyle: '#,##0.00;[Red](#,##0.00)' })
    })
  },
  findByKeyword() {
    this.allAfterFilter = this.all.filter((v) => !this.filterVal || `${v[this.filterKey] || ''}`.includes(this.filterVal))
    this.total = this.allAfterFilter.length
    this.handlePageChange(1)
  },
}

export default {
  data,
  mixins,
  computed,
  created,
  methods,
}
</script>


// WEBPACK FOOTER //
// src/views/manager-report/open-trades-report.vue